module.exports = __webpack_public_path__ + "img/bg1.c2f0f319.png";